<template>
    <div class="dropdownContainer">
        <SearchBar class="optionSearch" searchIcon="true" v-bind:search="search"
            v-bind:searchCallback="(data) => { this.filterOptions(data) }"> </SearchBar>
        <div class="optionContainer">
            <div class="option">
                <button v-for="option in localOptions" v-bind:key="option.value"
                    @click="() => onOptionSelected(option)">
                    <!-- <div class="optionLayout">
                        <p class="plusIcon">+</p>
                        <p class="value">Option Value</p>
                    </div> -->
                    <div class="optionLayout">
                        <p class="plusIcon">+</p>
                        <p class="value"> {{ option.name }}</p>
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
//import * as Constants from "../../js/constants"
import SearchBar from "../pages/pageComps/Search.vue";

export default {
    components: {
        SearchBar
    },
    props: ["options", "searchCallback", "onOptionSelected"],
    data() {
        return {
            search: "",
            localOptions: this.$props.options,
            selectedOption: null
        }
    },
    watch: {
        options: function (newVal) {
            console.log("New Options", newVal)
            this.localOptions = newVal
        }
    },
    methods: {
        filterOptions(data) {
            this.localOptions = this.$props.options.filter(
                item => item.name.includes(data)
            )

        }
    }

}
</script>

<style scoped>
.dropdownContainer {
    flex: 1;
    width: 100%;
    height: auto;
    background-color: white;
    z-index: 5;
}

.optionContainer {
    width: 100%;
    max-height: 150px;
    background-color: white;
    z-index: 5;
    padding: 4px 4px;
    overflow: scroll
}

.optionSearch {
    margin-top: 4px;
    margin-left: 10px;
    margin-right: 10px;
    font-size: 8px !important;
    align-items: center;
    border-radius: 4px;
    border: 1px solid black;
    width: initial;
    background-color: #F3F3F3;
}

::placeholder {
    font-weight: 100;
    color: #F3F3F3;
}

.option {
    width: 100%;
}

.option button {
    width: 100%;

}

.optionLayout {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin: 0px 8px;
    padding: 8px 8px;
    border-radius: 4px;

}

.optionLayout:hover {
    background-color: #6999911F;
    color: #699991;
    transition: 0.5s;
}

.plusIcon {
    flex: 1;
    align-self: center;
    border: 0;
}

.value {
    flex: 8;
    border: 0;
    font-weight: 400;

}
</style>